function init() {
    product = $(".product").ThreeSixty({
        totalFrames: 72,
        endFrame: 72,
        currentFrame: 1,
        imgList: ".threesixty_images",
        progress: ".spinner",
        imagePath: "https://hummkombucha.com/cdn/shop/files/",
        filePrefix: "humm-nitro-360-can-",
        ext: ".png",
        width: 322,
        height: 594,
        navigation: !1,
        playSpeed: 150,
        autoplay: !1,
        autoplayDirection: 0,
        onReady: function () {
            a();            
        },
    });

    var a = function () {
        var a = $(".threesixty").width(),
            b = $(".threesixty_images img").width(),
            c = 0;
        a > b && (c = (a - b) / 2), $(".threesixty_images img").css("left", c + "px");
        var d = $(".threesixty_images img").height();
    };
    product.gotoAndPlay(55);
    product.play();
    $(window).on("resize", a);
}
window.onload = init;
var product;